import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../shared/app-settings';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CameraServerService {
  constructor(public http: HttpClient, private toaster: ToastrService,) { }
  domainNameForMasking = environment.baseUrlForMasking; //coming from environment

  // Any change needs to connect test or uat modify it in environment.dev.ts, don't udpate it directly here and push the code.
  baseUrl = environment.camServerAPI;
  baseUrlAlarm = environment.camServerAlarmAPI;
  liveViewUrl = environment.camServerLiveViewAPI;
  cameraDayNightSync = environment.camServerDayNightImageSync;
  footageDownloadUrl = environment.footageDownload;

  /**Get All Sites Data */
  getAllSitesData(url: any, obj: any): Observable<any> {
    const httpOptions = {
      params: obj,
    };
    const backendAPIURL: string = `${this.baseUrl}cam/config/fetch?camUniqueId=729807VGSTESTHD7tCAM52551`;
    return this.http.get(backendAPIURL, httpOptions);
  }

  /**Get All Sites Data based on the user search */
  searchSitesData(
    queryParams: any,
    pageIndex: any,
    pageSize: any
  ): Observable<any> {
    const backendAPIURL: string = `${this.baseUrl
      }site/config/search?query=${queryParams}&pageNo=${pageIndex + 1
      }&pageSize=${pageSize}`;
    return this.http.post(backendAPIURL, {});
  }

  /**Get Site by potential ID */
  getSiteByPotentialId(potentialID: any): Observable<any> {
    const backendAPIURL: string = `${this.baseUrl}site/config/fetch?potentialId=${potentialID}`;
    return this.http.get(backendAPIURL);
  }

  /**Post Add Site */
  addSite(payload: any): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/add`;
    return this.http.post(`${apiUrl}`, payload);
  }

  /**Post Update Site */
  updateSite(payload: any): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/update`;
    return this.http.post(`${apiUrl}`, payload);
  }

  /**Delete Site */
  deleteSite(sitePotentialId: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/delete?camUniqueId=${sitePotentialId}`;
    return this.http.get(apiUrl);
  }

  /**Delete Site */
  deleteDevices(device_unique_id: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/devices/delete?deviceUniqueId=${device_unique_id}`;
    return this.http.get(apiUrl);
  }

  /**Update Analytic */
  updateAnalytic(payloads: string): Observable<any> {
    const apiUrl = `${this.baseUrl}site/config/update`;
    return this.http.post(apiUrl, payloads);
  }

  /**upload Site image based on the Camera ID */
  uploadSiteImage(formData: any, potentialId: any): Observable<any> {
    const apiUrl = `${this.baseUrl}upload/site/plan?potentialId=${potentialId}`;
    return this.http.post(apiUrl, formData);
  }

  /**Add devices  */
  addDevices(payloads: string, type: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/devices/add?deviceClass=${type}`;
    return this.http.post(apiUrl, payloads);
  }

  /**Add devices  */
  updateDevices(payloads: string, type: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/devices/update?deviceClass=${type}`;
    return this.http.post(apiUrl, payloads);
  }
  /** Get All devices  */
  getAllDevices(potentialId: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/devices/fetch/all?potentialId=${potentialId}`;
    return this.http.get(apiUrl);
  }

  /** Get device by device class name  */
  getDeviceByClass(potentialId: string, class_name: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/devices/fetch?potentialId=${potentialId}&deviceClass=${class_name}`;
    return this.http.get(apiUrl);
  }

  /** Get device by device unique ID  */
  getDeviceByDeviceUID(device_Unique_ID: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/devices/fetch/id?deviceUniqueId=${device_Unique_ID}`;
    return this.http.get(apiUrl);
  }

  /** Downloads Site  */
  downloadSite(potentialId: string): Observable<any> {
    const apiUrl = `${this.baseUrl}download/site/devices/excel?potentialId=${potentialId}`;
    return this.http.get(apiUrl, { responseType: 'blob' });
  }

  /**Get All Camera Data */
  getAllCameras(url: any, obj: any): Observable<any> {
    const httpOptions = {
      params: obj,
    };
    const backendAPIURL: string = `${this.baseUrl}cam/config/fetch?camUniqueId=729807VGSTESTHD7tCAM52551`;
    return this.http.get(backendAPIURL, httpOptions);
  }

  /**Get All camera Data based on the search */
  searchCam(query: string): Observable<any> {
    // Camera7
    const apiUrl = `${this.baseUrl}cam/config/search?query=${query}`;
    return this.http.get(apiUrl);
  }

  /**Get Camera based on the camera id */
  getCam(cameUniqId: string): Observable<any> {
    // 729807VGSTESTHD7tCAM52551
    const apiUrl = `${this.baseUrl}cam/config/fetch?camUniqueId=${cameUniqId}`;
    return this.http.get(apiUrl);
  }

  /**Get All camera based on the potential ID */
  getCamByPotentialId(potentialId: string): Observable<any> {
    // 729807
    const apiUrl = `${this.baseUrl}cam/config/fetch/cams?potentialId=${potentialId}`;
    return this.http.get(apiUrl);
  }

  /**Get All Ec2 */
  getAllEc2(): Observable<any> {
    const apiUrl = `${this.baseUrl}ec2/getall`;
    return this.http.get(apiUrl);
  }

  /**Save All Ec2 farm data */
  saveAllEc2(data: any): Observable<any> {
    const apiUrl = `${this.baseUrl}ec2/save`;
    return this.http.post(apiUrl, data);
  }

  /**Update All Ec2 farm data */
  updateAllEc2(id: any): Observable<any> {
    const apiUrl = `${this.baseUrl}ec2/update`;
    return this.http.put(apiUrl, id);
  }

  /**Delete All Ec2 farm data */
  deleteAllEc2(nodeName: string): Observable<any> {
    const apiUrl = `${this.baseUrl}ec2/delete?nodeName=${nodeName}`;
    // const apiUrl = `${this.baseUrl}ec2/save`;
    return this.http.get(apiUrl);
  }

  /**Post Add camera */
  addCam(payload: any): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/add`;
    return this.http.post(`${apiUrl}`, payload);
  }

  /**Post Update Camera */
  updateCam(payload: any): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/update`;
    return this.http.post(`${apiUrl}`, payload);
  }

  /**Delete Camera based on the Camera ID */
  deleteCam(camUniqueId: string): Observable<any> {
    const apiUrl = `${this.baseUrl}cam/config/delete?camUniqueId=${camUniqueId}`;
    return this.http.get(apiUrl);
  }

  /**Upload Day light Image */
  uploadDayNightImg(payload: any): Observable<any> {
    const apiUrl = `${this.baseUrl}upload/cam/dn?type=${payload.type}&camUniqueId=${payload.camUniqueId}&potentialId=${payload.potentialId}`;
    return this.http.post(`${apiUrl}`, payload.file);
  }

  /**Masking*/
  searchSiteBy(params: any): Observable<any> {
    const apiUrl = `${this.domainNameForMasking}mengine/admin/site/search?potentialId=${params.potentialId}&siteName=${params.siteName}&vpnIp=${params.vpnIp}`;
    return this.http.get(`${apiUrl}`);
  }

  getSiteDetailsForMasking(potentialId: any): Observable<any> {
    const apiUrl = `${this.domainNameForMasking}mengine/admin/masking/site/details?potentialId=${potentialId}`;
    return this.http.get(`${apiUrl}`);
  }

  getMasking(cam: any, requestParam: any): Observable<any> {
    const apiUrl = `${this.domainNameForMasking}mengine/admin/masking/getmasking/${cam['camUniqueId']}/${cam['resolution']}`;
    return this.http.get(`${apiUrl}`);
  }

  BlobImage(cam: any, site: any, url: string): Observable<any> {
    return this.http.get(
      `${this.domainNameForMasking}${url}/${cam['camUniqueId']}/${site?.potentialId}/${cam['resolution']}`,
      { responseType: 'arraybuffer' }
    );
  }

  saveUpdateMasking(requestBody: any): Observable<any> {
    return this.http.post(
      `${this.domainNameForMasking}mengine/admin/masking/saveupdatemasking`,
      requestBody
    );
  }

  UpdateRecord(payload: any): Observable<any> {
    const apiUrl = `${this.baseUrl}ec2/update`;
    return this.http.put(`${apiUrl}`, payload);
  }

  camImgForLiveView(
    potentialId: string,
    cameraId: string,
    timeStamp: any
  ): Observable<any> {
    const apiUrl = `${this.liveViewUrl}snap/manager/fetch/latest/image?potentialId=${potentialId}&camUniqueId=${cameraId}`;
    return this.http.get(`${apiUrl}`);
  }

  manualSyncMasking(
    potentialId: string,
    newResolution: string
  ): Observable<any> {
    const apiUrl = `${this.domainNameForMasking}mengine/admin/masking/sync/${potentialId}/${newResolution}`;
    return this.http.get(`${apiUrl}`);
  }

  checkPlateForm(): Observable<any> {
    const apiUrl = `${this.baseUrl}site/config/platform`;
    return this.http.get(`${apiUrl}`);
  }

  moveSiteToNewCamServer(payloads: any): Observable<any> {
    const apiUrl = `${this.baseUrl}site/config/profit/move/sites`;
    return this.http.post(`${apiUrl}`, payloads);
  }

  manualSyncSite(potentialId: any): Observable<any> {
    const apiUrl = `${this.baseUrl}manual/sync/all?potentialId=${potentialId}`;
    return this.http.get(`${apiUrl}`);
  }

  testDevices(potentialId: any, deviceId: any): Observable<any> {
    const apiUrl = `${this.baseUrlAlarm}trigger/alarms/strobes/fromConfigMngmt?potentialId=${potentialId}&deviceUniqId=${deviceId}`;
    return this.http.get(`${apiUrl}`);
  }

  footageDownload(payload: any): Observable<any> {
    const apiUrl = `${this.footageDownloadUrl}footage`;
    return this.http.post(`${apiUrl}`, payload);
  }

  getCancelSiteList(): Observable<any> {
    const apiUrl = `${this.baseUrl}site/config/fetch/list/cancelledsites`;
    return this.http.post(`${apiUrl}`, {});
  }

  deleteCancelSite(potentialId: any, modifiedByUser: string): Observable<any> {
    const apiUrl = `${this.baseUrl}site/config/removesite?potentialId=${potentialId}&modifiedby=${modifiedByUser}`;
    return this.http.get(`${apiUrl}`, {});
  }

  syncDayNightImageIndividualCam(data: any): Observable<any> {
    const apiUrl: string = `${this.cameraDayNightSync}manual/sync/dnimages/${data.potentialId}/${data.camUnqId}/${data.type}`;
    return this.http.get(apiUrl);
  }

  syncDayNightImageForAllCam(data: any): Observable<any> {
    const apiUrl: string = `${this.cameraDayNightSync}manual/sync/dnimages/${data.potentialId}/${data.type}`;
    return this.http.get(apiUrl);
  }

  footageDownloadQueue(page: number, size: number, userName: string): Observable<any> {
    const apiUrl: string = `${this.footageDownloadUrl}fetch?page=${page}&size=${size}&user_name=${userName}`;
    return this.http.get(apiUrl);
  }

  footageDownloadUsingS3(url: any): Observable<any> {
    const apiUrl: string = `${url}`;
    return this.http.get(apiUrl);
  }

  siteDumpAllExport(searchQuery: any) {
    let apiUrl: string = '';
    if (searchQuery === '') {
      apiUrl = `${this.baseUrl}site/config/sites/export`;
    } else {
      apiUrl = `${this.baseUrl}site/config/sites/export?query=${searchQuery}`;
    }
    return apiUrl;
  }

  rtspStream(rtsp: any): Observable<any> {
    const apiUrl = `${this.footageDownloadUrl}check_stream?rtsp_url=${rtsp}`;
    // const apiUrl = `http://localhost:8084/api/check_stream?rtsp_url=${rtsp}`;
    return this.http.get(apiUrl);
  }

  updateMaskByUniqId(camId: any) {
    const baseURL = `${this.domainNameForMasking}mengine/admin/masking/update/aid7?cameraUniqueId=${camId}`;
    return this.http.get(baseURL);
  }

  cancelFootageDownload(process_id: number): Observable<any> {
    const apiUrl: string = `${this.footageDownloadUrl}cancel/${process_id}`;
    return this.http.get(apiUrl);
  }
changeMaskingByUniqId(camId:any){
  const apiUrl = `${this.domainNameForMasking}mengine/admin/masking/oriaid7points/${camId}`;
  return this.http.get(apiUrl);
}
removeMaskingByUniqId(camId:any){
  const apiUrl = `${this.domainNameForMasking}mengine/admin/masking/remove/aid7/points/${camId}`;
  return this.http.get(apiUrl);
}
  byPassFootageDownloadToHeader(body:any){

  }
  //handle Instant download
  handleInstantDownloadFootage(body: any, camInfo:any,fromDate:any) {
    const apiUrl: string = `${this.footageDownloadUrl}download/footage`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'video/mp4' 
    });
     this.http.post(apiUrl, body,{
      headers: headers,
      responseType: 'blob' 
    }).subscribe((response:any)=>{
      if(response?.type === 'application/json'){
        const reader = new FileReader();
        reader.onload = () => {
          const errorResponse = JSON.parse(reader.result as string);
          this.toaster.error(errorResponse.status || 'An error occurred.');
        };
        reader.readAsText(response);
      }else {
        const fileName = `${camInfo?.cameraName}${fromDate}`;
        this.downloadMp4File(response,fileName)
        this.toaster.success(`File ${camInfo?.cameraName} ${fromDate} Successfully Downloaded`);
      }
    })
  }
  downloadMp4File(response, fileName){
    const url = window.URL.createObjectURL(response);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${fileName}.mp4`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  //handle export, delete, import api calls
  exportSite(potential_id:number):Observable<any>{
    const apiUrl:string = `${this.baseUrl}site/data/export?potentialId=${potential_id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get(apiUrl,{
      headers: headers,
      responseType: 'blob', 
      observe: 'response' as 'body' 
    });
  }
  //handle delete functionality 
  deleteSiteFarm(potential_id:number,userName:any){
  const apiUrl = `${this.baseUrl}site/config/removesite?potentialId=${potential_id}&modifiedby=${userName}`;
  return this.http.get(apiUrl);
  }
  //import site 
  importSite(formData: FormData): Observable<any>{
    const apiUrl = `${this.baseUrl}site/data/import`;
    return this.http.post(apiUrl, formData)  
  }
}